import React from 'react'





export default function RateioComponent(props) {

    return (
        <div style={{ textAlign: 'center' }}>
            <p>Confirma o rateio automático de {props.product.prod_descricao} ?</p>
        </div>

    )
}